import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { DonutChartModule, IconModule } from '@hglobal/common';
import { CoinComponent } from '@pt/components';
import { TransactionChart } from '@pt/models';

@Component({
  selector: 'pt-transaction-text-total',
  templateUrl: './transaction-text-total.component.html',
  styleUrls: ['./transaction-text-total.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DonutChartModule, IconModule, TranslateModule, CoinComponent],
})
export class TransactionTextTotalComponent {
  chart = input.required<TransactionChart>();

  readonly total = computed(() => {
    const { metrics } = this.chart();
    return metrics.reduce((acc, metric) => acc + metric.amount, 0);
  });
}
